import React from 'react';

function DefaultColumnFilter({ column: { filterValue, setFilter } }) {
    return (
        <input
            value={filterValue || ''}
            onChange={(e) => setFilter(e.target.value || undefined)} // 设置过滤值
            placeholder="搜索..."
        />
    );
}

export default DefaultColumnFilter;